import { Card,Select,Table,Layout, Row, Col, Input, Space, Button, Divider, Collapse,  Checkbox,
    DatePicker, Tabs, Tooltip, 
    Popconfirm, Drawer} from 'antd';
import { Content, Footer, Header } from "antd/es/layout/layout";
import { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './MeetingFollowUp.scss'
import { alertService } from '../../../../Shared/Utils/ToasterUtils';
import { ServiceUtils } from '../../../../Shared/Utils/ServiceUtils';
import BreadcrumbList from '../../../../Shared/Components/Breadcrumb/Breadcrumb';
import classNames from 'classnames';
import { useSharedState } from '../../../../Shared/Services/WindowSizeService';
import { CaretRightOutlined, CloseOutlined, FilterOutlined } from "@ant-design/icons";
import {
    SearchOutlined
  } from "@ant-design/icons";
  import moment from "moment";
  import useWindowSize from '../../../../Shared/Utils/windowResizeUtils';
import Search from 'antd/es/input/Search';
import HomeFollowUpCards from './HomeFollowUpCards';
  const { RangePicker } = DatePicker;
  const {  Sider } = Layout;
const MeetingFollowUp = () => {
    const [hierarchy, setHierarchy] = useState([{ label: 'FollowUp', link: '' }]);
    const [tableData, setTableData] = useState({
        headerContent: [],
        bodyContent: []
    });
    const [defaultOptions, setDefaultOptions] = useState(['Meeting','Conference','General']);
    const dropdownOptions = [
        {
            label:"Meeting",
            value:"Meeting"
        },
        {
            label:"Conference",
            value:"Conference"
        },
        {
            label:"General",
            value:"General"
        }
    ];
    const [searchText, setSearchText] = useState("");
    const [filterOptionsActiveData, setFilterOptionsActiveData] = useState({});
    const [filterSelectedData, setFilterSelectedData] = useState({});
    const [showFilterFlag, setShowFilterFlag] = useState(false);
    const [filterAction, setFilterAction] = useState(null); 
    const [openDrawer, setOpenDrawer] = useState(false);
    const [filtersData, setFiltersData] = useState([]);

    const navigate = useNavigate();
    const windowSize$ = useSharedState();
    const { width } = useWindowSize();
    const isMobile = width <= 430;
    const isIpad = width <= 820;
    const sliderWidth = isMobile ? 150 : 250;

    const columns = [
        ...tableData?.headerContent,
        {
          title: "Action",
          key: "action",
          width: 80,
          render: (text, record) => (
            <div>
              <Button type="link" onClick={() => onEdit(record)}>
                Edit
              </Button>
              <Popconfirm
                title="Delete "
                description="Are you sure to delete this followup?"
                okText="Yes"
                cancelText="No"
                onCancel={() => { }}
                onConfirm={() => { onDelete(record)}}
                getPopupContainer={() => document.body}
              >
                <Button type="link" danger>
                  Delete
                </Button>
              </Popconfirm>
            </div>
          ),
        },
      ];

      const handleChange = (data) => {
        switch(data?.type) {
          case 'edit':
            onEdit(data?.data);
            break;
          case 'delete':
            onDelete(data?.data);
            break;
        }
      }
    
      const onEdit = (record) => {
        navigate(`/home/editFollowUp/${record.followup_id}`);
      };

      const onDelete = (record) => {
        let payload = {
          "data": {
            "type": "delete",
            "followup_id": record.followup_id
          }
        }
        ServiceUtils.postRequest("saveFollowup",payload).then(
          (response) => {
            if (response.status === 200 && response?.data.status) {
              alertService.success(response.data.message);
              fetchTableData();
            } else if(response.status === 401 ){
                navigate('/logout');
            } else {
              alertService.error(response.data.message);
            }
          },
          (error) => {
            alertService.error("Error while fetching Data.");
          }
        );
      }


    useEffect(()=>{
        fetchTableData();
    },[defaultOptions]);

    useEffect(() => {
      if (filterAction === 'onSearch') {
        applyFilters();
      }
    }, [filterSelectedData]);

    const onFilterChange = (value) => {
        setDefaultOptions(value);
    };

    const fetchTableData = (filterJson) => {
        let payload = {
            filters: filterJson ? filterJson : {},
            searchText: searchText
        }
        ServiceUtils.postRequest("followups", payload).then(
            (response) => {
                if (response.status === 200 && response?.data.status) {
                    setTableData(response?.data?.data?.tableData);
                    let filterres = JSON.parse(JSON.stringify(response.data?.data?.filters?.filterData))
                    let filterPay = JSON.parse(JSON.stringify(response.data?.data?.filters?.filterKeys))
                    // setFilterActiveDefaultData(filterPay);
                    getActiveFilterStructure(filterres, filterPay);
                } 
                else if(response.status === 401 ){
                    navigate('/logout');
                }
                else {
                    alertService.error(response.data.message);
                }
            },
            (error) => {
                alertService.error("Error while fetching Data.");
            }
        );
    };

    const filter = (input, option) => {
        return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
    };

    const handleSearchInputChange = (event) => {
        setSearchText(event.target.value);
      };

      const handleKeypress = (e) => {
        if (e.key === "Enter") {
            fetchTableData();
        }
      };

      const getActiveFilterStructure = (data, reqObj) => {
        let datattt = data;
        let reqObject = reqObj;
    
        const onChangeFilters = (data, key,type = "") => {
            reqObject = { ...filterSelectedData, ...reqObject, [key]: data }
            setFilterAction(type);
            setFilterSelectedData(reqObject);
        }
        datattt?.map((item) => {
          if (item.type === "checkBox") {
            const getData = () => {    
              return (
                [
                  <Checkbox.Group onChange={(e) => { onChangeFilters(e, item?.key) }} defaultValue={item?.defaultValue}>
                    <Space direction="column">
                      <Row gutter={16}>
                        {item?.options?.map((option) => (
                          <Col span={24}>
                            <Checkbox value={option?.value} style={{ marginBottom: '3px' }}>{option?.label}</Checkbox>
                          </Col>
                        ))}
                      </Row>
                    </Space>
                  </Checkbox.Group>
                ]
              )
            }
            item["children"] = getData();
          }
          else if (item.type === "date-picker") {
            const getCAlData = () => {
              return (
                <div style={{ paddingBottom: '5px' }}>
                  <RangePicker
                    // showTime={{
                    //   format: 'HH:mm',
                    // }}
                    // onChange={(e)=>{console.log(e)}}
                    defaultValue={[moment(...item?.defaultValue[0]), moment(...item?.defaultValue[1])]}
                    placeholder={["Start", "End"]}
                    format="YYYY-MM-DD HH:mm"
                    onChange={(value, dateString) => { onChangeFilters(dateString, item?.key) }}
                  // onOk={onOk}
                  />
                </div>
              )
            }
            item["children"] = getCAlData();
          } else if (item.type === "input") {
            const getData = () => {
              return (
                <Search
                  placeholder={item?.label}
                  allowClear
                  enterButton={<SearchOutlined />}
                  style={{ margin: "10px 0", fontSize: "13px" }}
                  size="middle"
                  onChange={(e) => onChangeFilters(e.target.value, item?.key, 'onChange')}
                  onSearch={(value) => onChangeFilters(value, item?.key, 'onSearch')}
                  defaultValue={item?.defaultValue || ''}
                />
              );
            };
            item["children"] = getData();
          } else if (item.type === "dropdown") {
            const getData = () => {
              return (
                <Select
                  allowClear
                  showSelectAll={true}
                  mode="multiple"
                  style={{
                    width: "100%",
                    margin: "5px"
                  }}
                  // value={reqKOLIds}
                  defaultValue={item.defaultValue}
                  showSearch
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  onChange={(value, label) => { onChangeFilters(value, item?.key) }}
                  options={item?.options}
                  // tagRender={tagRender}
                >
                </Select>
              );
            };
            item["children"] = getData();
          }
        })
        setFilterOptionsActiveData(datattt);
      }

      const onChangeCollapse = (key) => {
        // console.log(key);
      };

      const clearAll = () => {
        // console.log()
        setShowFilterFlag(false);
      }

      const applyFilters = () => {
        setOpenDrawer(false); 
        setShowFilterFlag(false);
        fetchTableData(filterSelectedData);
      }

      const showDrawer = () => {
        setOpenDrawer(true);
      };
     
      const onClose = () => {
        setShowFilterFlag(false);
        setOpenDrawer(false);
      }

    return (
      <div className="MeetingFollowUp">
        <Card
          style={{ width: "100%", height: "fit-content" }}
          bodyStyle={{ padding: "10px" }}
        >
          <BreadcrumbList active={hierarchy} />
        </Card>
        <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px 2px 10px" }}>
          <>
            {
              showFilterFlag ?
                <Drawer
                  title="Filters"
                  // width={720}
                  size="default"
                  onClose={onClose}
                  open={openDrawer}
                  styles={{
                    body: {
                      paddingBottom: 80,
                      padding: 2,
                    },
                  }}
                  footer={
                    <Space>
                      <Button className="edit-meet-button" type="primary"  onClick={() =>
                                  applyFilters()
                                }>
                        Apply
                      </Button>
                      <Button onClick={onClose}>Cancel</Button>
                    </Space>
                  }
                >
                  <Collapse
                    defaultActiveKey={['1']}
                    style={{
                      border: 'none',
                      borderRadius: '0px',
                    }}
                    onChange={onChangeCollapse}
                    expandIconPosition='end'
                    items={filterOptionsActiveData}
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                  />
                </Drawer>
                :
                <div style={{padding:'5px'}}>
                  <Tooltip title="Filters">
                    <Button onClick={() => { setOpenDrawer(true); setShowFilterFlag(true) }}>

                      <FilterOutlined />
                    </Button>
                  </Tooltip>
                </div>
            }
          </>
          <div style={{padding:'5px'}}>
            <Button type="primary" onClick={() => navigate("/home/CreateFollowUp")}>
              Add Follow-up
            </Button>
          </div>
        </div>
        <>
          {
            <Layout>
              {/* <div> */}
                {/* {
                  showFilterFlag ?
                    <Sider
                      width={sliderWidth}
                      style={{
                        overflow: 'visible'
                      }}
                    >
                      <Layout style={{ height: '-webkit-fill-available' }}>
                        <Header className="followup-filter-header" style={{ "padding": "0px !important" }}>
                          <div className="demo-logo-vertical" />
                          <Row gutter={16} style={{ padding: '0px', margin: '0px' }}>
                            <Col span={12}>
                              <b>Filters</b>
                            </Col>
                            <Col span={12} style={{ alignSelf: 'center' }}>
                              <span style={{ opacity: '0.5', display: 'flex', justifyContent: 'end' }} onClick={clearAll} className="pointer">
                                <CloseOutlined />
                              </span>
                            </Col>
                          </Row>
                          <Divider />
                        </Header>
                        <Layout>
                          <Content className="followup-filter-content">
                            <Collapse
                              defaultActiveKey={['1']}
                              onChange={onChangeCollapse}
                              expandIconPosition='end'
                              items={filterOptionsActiveData}
                              expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                            />
                          </Content>
                        </Layout>
                        <Footer>
                          <div className="submit-block" style={{ marginBottom: '5px' }}>
                            <div style={{ paddingRight: "10px" }}>
                              <Button
                                className="edit-meet-button"
                                type="primary"
                                onClick={() =>
                                  applyFilters()
                                }
                              >
                                Apply
                              </Button>
                              <Button style={{ 'marginLeft': '5px' }}>Reset</Button>
                            </div>
                          </div>
                        </Footer>
                      </Layout>

                    </Sider> :
                    <div>
                      <Tooltip title="Filters">
                        <Button style={{ margin: '15px' }} onClick={() => { setShowFilterFlag(true) }}>

                          <FilterOutlined />
                        </Button>
                      </Tooltip>
                      <Sider width={'5%'} />
                    </div>
                } */}
              {/* </div> */}
              <>
                {
                  isIpad ? (
                    <HomeFollowUpCards
                      columns={columns}
                      dataSource={tableData?.bodyContent.map((item, index) => ({
                        ...item,
                        key: item.id || index, // Ensure each row has a unique key
                      }))}
                      onAction={handleChange}
                    />
                  ) : (
                    <Content>
                      <div className={classNames("", {
                        "follow-container":
                          windowSize$ === "lg" ||
                          windowSize$ === "xl" ||
                          windowSize$ === "xxl",
                        "follow-container-small": windowSize$ === "xs" || windowSize$ === "sm" || windowSize$ === "md",
                      })}>
                        <Table
                          columns={columns}
                          dataSource={tableData?.bodyContent.map((item, index) => ({
                            ...item,
                            key: item.id || index, // Ensure each row has a unique key
                          }))}
                          pagination={false}
                          scroll={{
                            y: "calc(100vh - 270px)",
                          }}
                        />
                      </div>
                    </Content>
                  )
                }
              </>
            </Layout>
          }
        </>
      </div>
    )
}

export default MeetingFollowUp;